import { ProfessionalTeamRoleKind } from '@/types/schema';

// Members render in two columns, filling the left column before the right. A
// member with an email occupies a third line, so a page that holds anyone
// with an email fits twelve per column; a page of only email-less members
// fits thirteen. Page length is two full columns, after which members
// paginate onto another slide.
export const PROFESSIONAL_TEAM_COLUMN_LENGTH_WITH_EMAIL = 12;
export const PROFESSIONAL_TEAM_COLUMN_LENGTH_NO_EMAIL = 13;
export const PROFESSIONAL_TEAM_PAGE_LENGTH_WITH_EMAIL =
  PROFESSIONAL_TEAM_COLUMN_LENGTH_WITH_EMAIL * 2;
export const PROFESSIONAL_TEAM_PAGE_LENGTH_NO_EMAIL =
  PROFESSIONAL_TEAM_COLUMN_LENGTH_NO_EMAIL * 2;

export const ADVISOR_CLIENT_TEAM_ORDER_LIST: ProfessionalTeamRoleKind[] = [
  ProfessionalTeamRoleKind.FinancialAdvisor,
  ProfessionalTeamRoleKind.AccountantCpa,
  ProfessionalTeamRoleKind.Attorney,
  ProfessionalTeamRoleKind.InsuranceAgent,
  ProfessionalTeamRoleKind.BusinessManager,
  ProfessionalTeamRoleKind.Bookkeeper,
  ProfessionalTeamRoleKind.Other,
];

export const PRINCIPAL_CLIENT_TEAM_ORDER_LIST: ProfessionalTeamRoleKind[] = [
  ProfessionalTeamRoleKind.PowerOfAttorney,
  ProfessionalTeamRoleKind.Physician,
  ProfessionalTeamRoleKind.HealthcareAgent,
  ProfessionalTeamRoleKind.Guardian,
  ProfessionalTeamRoleKind.Conservator,
  ProfessionalTeamRoleKind.EstateExecutor,
  ProfessionalTeamRoleKind.Other,
];
